import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

export const CONDITIONS = [["etat_frais", "État frais"], ["extemporane", "Extemporané"], ["urgent", "Urgent"], ["semi_urgent", "Semi-urgent"],
  ["routine", "Routine"], ["formol", "Formol 10 %"], ["beno_michel", "Beno-Michel"], ["azf", "AZF"]];
export const SITES = "ABCDEFGHIJKLMNOPQRSTUV".split("");
const FIELDS = [["date_prelevement", "*Date de prélèvement", "date"], ["heure_prelevement", "*Heure de prélèvement", "time"],
  ["heure_fixation", "Heure de fixation", "time"], ["prochain_rdv", "Date du prochain rendez-vous", "text"],
  ["no_salle_tel", "No salle et téléphone", "text"], ["no_pratique", "*No de pratique", "text"],
  ["preleveur", "Préleveur (si différent)", "text"], ["service", "Service (ex. Gastroentérologie)", "text"],
  ["cc1", "C.C. (1)", "text"], ["cc2", "C.C. (2)", "text"]];

const hl = (unc, k) => (unc?.includes(k) ? "ring-2 ring-amber-400" : "");

export const RequeteFields = ({ value, onChange, incertitudes }) => {
  const r = value || {};
  const set = (k, v) => onChange({ ...r, [k]: v });
  const toggle = (k) => set("conditions", (r.conditions || []).includes(k) ? r.conditions.filter((c) => c !== k) : [...(r.conditions || []), k]);
  return (
    <div className="space-y-3 rounded-lg border border-slate-200 p-3" data-testid="requete-fields">
      <div className="text-xs font-bold uppercase tracking-wide text-slate-600">Requête d'anatomo-pathologie</div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {CONDITIONS.map(([k, l]) => (
          <label key={k} className="flex items-center gap-2 text-sm cursor-pointer">
            <Checkbox checked={(r.conditions || []).includes(k)} onCheckedChange={() => toggle(k)} data-testid={`requete-cond-${k}`} /> {l}
          </label>
        ))}
      </div>
      <div className="grid grid-cols-2 gap-2">
        {FIELDS.map(([k, l, type]) => (
          <div key={k}><Label className="text-xs">{l}</Label>
            <Input type={type} value={r[k] || ""} onChange={(e) => set(k, e.target.value)} className={hl(incertitudes, k)} data-testid={`requete-${k}`} /></div>
        ))}
        <div className="col-span-2"><Label className="text-xs">*Diagnostic pré-opératoire</Label>
          <Input value={r.diagnostic_preop || ""} onChange={(e) => set("diagnostic_preop", e.target.value)} className={hl(incertitudes, "diagnostic_preop")} data-testid="requete-diagnostic_preop" /></div>
        <div className="col-span-2"><Label className="text-xs">*Opération</Label>
          <Input value={r.operation || ""} onChange={(e) => set("operation", e.target.value)} className={hl(incertitudes, "operation")} data-testid="requete-operation" /></div>
      </div>
      <div>
        <Label className="text-xs">Site du prélèvement</Label>
        <div className={`grid grid-cols-1 md:grid-cols-2 gap-1 mt-1 ${hl(incertitudes, "sites")}`}>
          {SITES.map((s) => (
            <div key={s} className="flex items-center gap-1">
              <span className="w-6 text-center text-xs font-bold text-slate-500">{s}</span>
              <Input className="h-8 text-sm" value={r.sites?.[s] || ""} onChange={(e) => { const next = { ...(r.sites || {}), [s]: e.target.value }; if (!e.target.value.trim()) delete next[s]; set("sites", next); }} data-testid={`requete-site-${s}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
